<template>
  <div class="examSeting">
    <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
      <el-tab-pane label="考试项目" name="1">
        <div>
          <el-form :inline="true" :model="subjectParams" class="demo-form-inline">
            <el-form-item label="项目名称:">
              <el-input v-model="subjectParams['filter[name]']" clearable placeholder="项目名称"></el-input>

            </el-form-item>

            <el-form-item>
              <el-button type="primary" size="medium" @click="getSubjects">查询</el-button>
              <el-button type="success" size="medium" @click="handleAddSubject">新增</el-button>
            </el-form-item>
          </el-form>
        </div>
        <el-table :data="subjectList" border>

          <el-table-column prop="id" label="项目序号">
          </el-table-column>
          <el-table-column prop="name" label="项目名称">
          </el-table-column>
          <el-table-column prop="description" label="描述">
          </el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button type="warning" size="small" @click="handleEditSubject(scope)">修改</el-button>
              <el-button size="small" type="danger" @click="deleteSubject(scope)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div style="text-align: right;margin-top:20px">
          <el-pagination background @current-change="subjectPageCurrentChange" :page-count="pageformSubject.pages"
            :current-page="pageformSubject.pageNum" layout="prev, pager, next" :total="pageformSubject.total"
            :page-size="pageformSupply.pageSize">
          </el-pagination>
        </div>
      </el-tab-pane>
      <el-tab-pane label="病例" name="2" @tab-click="getCases">
        <div>
          <el-form :inline="true" :model="caseParams" class="demo-form-inline">
            <el-form-item label="病例名称:">
              <el-input v-model="caseParams['filter[name]']" clearable placeholder="病例名称"></el-input>

            </el-form-item>
            <el-form-item>
              <el-button type="primary" size="medium" @click="getCases">查询</el-button>
              <el-button type="success" size="medium" @click="handleAddCase">新增</el-button>
            </el-form-item>
          </el-form>
        </div>
        <el-table :data="caseList" border>
          <el-table-column prop="name" label="名称">
          </el-table-column>
          <el-table-column prop="description" label="描述">
          </el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button type="warning" size="small" @click="handleEditCase(scope)">修改</el-button>
              <el-button size="small" type="danger" @click="deleteCase(scope)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div style="text-align: right;margin-top:20px">
          <el-pagination background @current-change="casePageCurrentChange" :page-count="pageformCase.pages"
            :current-page="pageformCase.pageNum" layout="prev, pager, next" :total="pageformCase.total" :page-size="pageformCase.pageSize">
          </el-pagination>
        </div>
      </el-tab-pane>
      <el-tab-pane label="用物" name="3">
        <div>
          <el-form :inline="true" :model="supplyParams" class="demo-form-inline">
            <el-form-item label="用物名称:">
              <el-input v-model="supplyParams['filter[name]']" clearable placeholder="用物名称"></el-input>

            </el-form-item>
            <el-form-item>
              <el-button type="primary" size="medium" @click="getSupplies">查询</el-button>
              <el-button type="success" size="medium" @click="handleAddSupply">新增</el-button>
            </el-form-item>
          </el-form>
        </div>
        <el-table :data="supplyList" border>

          <el-table-column prop="name" label="名称">
          </el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button type="warning" size="small" @click="handleEditSupply(scope)">修改</el-button>
              <el-button size="small" type="danger" @click="deleteSupply(scope)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div style="text-align: right;margin-top:20px">
          <el-pagination background @current-change="supplyPageCurrentChange" :page-count="pageformSupply.pages"
            :current-page="pageformSupply.pageNum" layout="prev, pager, next" :total="pageformSupply.total" :page-size='10'>
          </el-pagination>
        </div>
      </el-tab-pane>
    </el-tabs>
    <el-dialog :visible.sync="subjectDialogVisible" :title="subjectDialogType==='edit'?'编辑考试项目':'新增考试项目'">
      <el-form :model="subject" label-width="150px" label-position="left">
        <el-form-item label="项目名称">
          <el-input v-model="subject.name" placeholder="项目名称" style="width: 80%" />
        </el-form-item>
        <el-form-item label="时间限制(分钟)">
          <el-input v-model="subject.mins" placeholder="时间限制" style="width: 80%" />
        </el-form-item>
        <el-form-item label="相关病例">
          <el-select v-model="subject.cases" multiple placeholder="请选择">
            <el-option v-for="item in caseList" :key="item.id" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="项目描述">
          <el-input type="textarea" v-model="subject.description" placeholder="项目描述" style="width: 80%" />
        </el-form-item>
        <el-form-item label="考试用物">
          <el-button type="primary" @click="addSubjectSupply()" size="medium" class="add">新增用物</el-button>
          <el-table :data="subject.supply" border>
            <el-table-column label="用物">
              <template slot-scope="scope">
                <el-select v-model="scope.row.id" filterable placeholder="请选择">
                  <el-option v-for="item in supplyList" :key="item.id" :label="item.name" :value="item.id">
                  </el-option>
                </el-select>
              </template>
            </el-table-column>
            <el-table-column label="数量">
              <template slot-scope="scope">
                <el-input v-model="scope.row.number" placeholder="数量" style="width: 80%" />
              </template>
            </el-table-column>
            <el-table-column label="操作">
              <template slot-scope="scope">
                <el-button type="text" size="small" @click="deleteSubjectSupply(scope.$index)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-form-item>
      </el-form>
      <div style="text-align:right;">
        <el-button type="danger" @click="subjectDialogVisible=false">取消</el-button>
        <el-button type="primary" @click="confirmSubject">保存</el-button>
      </div>
    </el-dialog>
    <el-dialog :visible.sync="caseDialogVisible" :title="caseDialogType==='edit'?'编辑病例':'新增病例'" width="75%">
      <el-form :model="cases" label-width="100px" label-position="left">
        <el-form-item label="病例名称">
          <el-input v-model="cases.name" placeholder="病例名称" style="width: 80%" />
        </el-form-item>
        <el-form-item label="病例描述">
          <el-input type="textarea" v-model="cases.desc" placeholder="病例描述" style="width: 80%" />
        </el-form-item>
        <el-form-item label="评分标准">
          <div style="display: inline-table">
            <div style="float: left">
              总分：
            </div>
            <el-input v-model="cases.total" @input="rate_scoreChange" style="float: left;width:12%"></el-input>
            <span style="margin-left: 20px;" v-if="cases.rate_choose != 1">折算后总分：{{cases.rate_score}}</span>
            <el-button style="float: right;margin-left: 10px;" size="small" @click="download">下载模板</el-button>
            <el-button style="float: right" type="primary" size="small">导入模板</el-button>
            <el-button style="float: right" type="primary" size="small" @click="addTableRow">新增考核点</el-button>
          </div>
        </el-form-item>
        <!-- 折算率选择 -->
        <el-form-item label="成绩折算">
          <el-select v-model="cases.rate_choose" @change="rate_chooseChange" placeholder="请选择" style="width: 29%;margin-right: 20px;">
            <el-option label="不需要折算" value="1">
            </el-option>
            <el-option label="统一折算率" value="2">
            </el-option>
            <el-option label="自定义折算" value="3">
            </el-option>
          </el-select>
          <!-- 折算率 -->
          <span v-if="cases.rate_choose == 2">折算率：</span>
          <el-input v-if="cases.rate_choose == 2" v-model="cases.conversionRate" @input="rate_scoreChange" style="width: 20%" />
        </el-form-item>
        <!-- 表格 -->
        <el-table :data="tableData" style="width: 100%;margin-bottom: 20px;" row-key="number" border default-expand-all
          :tree-props="{children: 'children', hasChildren: 'hasChildren'}">
          <el-table-column prop="number"  width="200" label="序号"></el-table-column>
          <el-table-column label="考核内容"   >
            <template slot-scope="scope">
              <div v-if="scope.row.isAdd">
                <span>考核点:</span>
                <el-input type="text" v-model="scope.row.content"  style="width: 80%"/>
              </div>
              <div v-if="!scope.row.isAdd">
                <span>考核项目:</span>
                <el-input type="text" v-model="scope.row.project" style="width: 80%"/>
              </div>
              <div v-if="!scope.row.isAdd" style="margin-top: 10px;">
                <span>评分标准:</span>
                <el-input type="text" v-model="scope.row.score"  style="width: 80%"/>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="分数" width="200">
            <template slot-scope="scope">
              <div v-if="scope.row.isAdd">考核点总分：{{scope.row.total}}
                <div v-if="cases.rate_choose == 3"> <span>折算率:</span>
                  <el-input type="text" v-model="scope.row.conversionrate" @change="conversionrateChange()" style="width: 50%;" />
                </div>
              </div>
              <el-select v-if="!scope.row.isAdd" v-model="scope.row.total_select" @change="tableSelectHandle(scope.row)"
                placeholder="请选择" style="width: 100%;">
                <el-option v-for="(item, index) in 50" :value-key="index" :key="'tb'+index" :label="index+1" :value="index + 1">
                </el-option>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="200">
            <template slot-scope="scope">
              <i class="el-icon-plus" style="margin-right: 10px;" v-if="scope.row.isAdd" @click="addTableRowHandle(scope.$index, scope.row)"></i>
              <i class="el-icon-upload2" style="margin-right: 10px;" @click="topHandle(scope.$index, scope.row,scope)"></i>
              <i class="el-icon-download" style="margin-right: 10px;" @click="downHandle(scope.$index, scope.row)"></i>
              <i class="el-icon-delete" style="color: red;" @click="deleteTableRowHandle(scope.$index, scope.row)"></i>
            </template>
          </el-table-column>
        </el-table>
        <el-checkbox v-model="cases.special_score_flag" style="margin-bottom: 20px;">特殊评分项</el-checkbox>
        <el-button style="float: right" type="primary" size="small" v-if="cases.special_score_flag" @click="addFlagHandle">新增特殊评分项</el-button>
        <!-- 表格 -->
        <el-table v-if="cases.special_score_flag" :data="cases.special_score" style="width: 100%;margin-bottom: 20px;"
          border default-expand-all>
          <el-table-column prop="name" label="名称" width="200">
            <template slot-scope="scope">
              <el-input type="text" v-model="scope.row.title" style="width: 100%;" />
            </template>
          </el-table-column>
          <el-table-column prop="address" label="分数">
            <template slot-scope="scope">
              <el-input type="text" v-model="scope.row.score" style="width: 100%;" />
            </template>
          </el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <i class="el-icon-delete" style="color: red;" @click="removeFlagHandle(scope.$index, scope.row)"></i>
            </template>
          </el-table-column>
        </el-table>
      </el-form>
      <div style="text-align:right;">
        <el-button type="danger" @click="caseDialogVisible=false">取消</el-button>
        <el-button type="primary" @click="confirmCase">保存</el-button>
      </div>
    </el-dialog>
    <el-dialog :visible.sync="supplyDialogVisible" :title="supplyDialogVisible==='edit'?'编辑用物':'新增用物'">
      <el-form :model="supply" label-width="150px" label-position="left">
        <el-form-item label="用物名称">
          <el-input v-model="supply.name" placeholder="用物名称" style="width: 80%" />
        </el-form-item>
      </el-form>
      <div style="text-align:right;">
        <el-button type="danger" @click="supplyDialogVisible=false">取消</el-button>
        <el-button type="primary" @click="confirmSupply">保存</el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>
  export default {
    props: {},
    data() {
      return {
        tables: [],
        subjectList: [],
        subject: {},
        cases: {
          name: "",
          desc: "",
          total: "",
          rate_score: "",
          rate_choose: "1",
          special_score_flag: 0,
          score: "1",
          special_score: [],
          conversionRate: 0
        },
        supply: {},
        subjectDialogVisible: false,
        subjectDialogType: 'new',
        caseList: [],
        caseDialogVisible: false,
        caseDialogType: 'new',
        supplyList: [],
        supplyDialogVisible: false,
        supplyDialogType: 'new',
        activeName: '1',
        subjectParams: {},
        caseParams: {},
        supplyParams: {},
        // 分页插件
        pageformSubject: {
          total: 10,
          pages: 10, // 总页数
          pageNum: 1, // 当前的页码
          pageSize: 20, // 每页显示条目个数
        },
        pageformCase: {
          total: 10,
          pages: 10, // 总页数
          pageNum: 1, // 当前的页码
          pageSize: 20, // 每页显示条目个数
        },
        pageformSupply: {
          total: 10,
          pages: 10, // 总页数
          pageNum: 1, // 当前的页码
          pageSize: 20, // 每页显示条目个数
        },
        tableData: [
          //   { //数据格式
          //   number: 1, //重要数据，在各操作中都有用到
          //   content: '', //考核点
          //   total: "1", //考核点总分
          //   total_select: "", //考核点分数选择
          //   conversionrate: "", //折算率
          //   project: "", //考核项目
          //   score: "", //评分标准
          //   isAdd: true, //用于判断是否是一级数据
          //   children: []
          // },
        ],
      };
    },
    computed: {},
    created() {
      this.getSubjects();
      this.getSupplies();
      this.getCases();
    },
    methods: {
      // 行上移
      topHandle(index, row) {
        if (index == 0) {
          return false;
        }
        // 点击一级行的编码
        if (row.isAdd) {
          let idx = this.tableData.findIndex((res) => {
            return res.number == row.number;
          });
          let number = this.tableData[idx].number;
          let object = this.tableData[idx];
          object["number"] = number - 1;
          this.tableData[idx - 1]["number"] = number;
          if (row.children.length > 0) {
            row.children.forEach((res) => {
              res["number"] = row.number + "-" + res["number"].split("-")[1];
            });
          }
          if (this.tableData[idx - 1].children.length > 0) {
            this.tableData[idx - 1].children.forEach((res) => {
              res["number"] = number + "-" + res["number"].split("-")[1];
            });
          }
          this.tableData.splice(idx, 1);
          this.tableData.splice(idx - 1, 0, object);
        } else {
          let idx1 = null; //一级下标
          let idx2 = null; //二级下标
          this.tableData.forEach((res, index1) => {
            if (res.children.length > 0) {
              res.children.forEach((res2, index2) => {
                if (res2.number == row.number) {
                  idx2 = index2;
                  idx1 = index1;
                }
              });
            }
          });
          if (idx2 == 0) {
            return false;
          }
          let data = this.tableData[idx1].children;
          let n = data[idx2].number.split("-");
          let number = n[1];
          let object = data[idx2];
          data[idx2 - 1]["number"] = object.number;
          object["number"] = n[0] + "-" + (n[1] - 1);
          data.splice(idx2, 1);
          data.splice(idx2 - 1, 0, object);
        }
      },
      // 行下移
      downHandle(index, row) {
        let length = this.tableData.length;
        let idx = null;
        let idx1 = null; //一级下标
        let idx2 = null; //二级下标
        this.tableData.forEach((res, index1) => {
          length = res.children.length + length;
          if (res.number == row.number) {
            idx = index1;
          }
          if (res.children.length > 0) {
            res.children.forEach((res2, index2) => {
              if (res2.number == row.number) {
                idx2 = index2;
                idx1 = index1;
              }
            });
          }
        });
        if (index >= length - 1) {
          return false;
        }
        // 点击一级行的编码
        if (row.isAdd) {
          let number = this.tableData[idx].number;
          let object = this.tableData[idx];
          object["number"] = number + 1;
          this.tableData[idx + 1]["number"] = number;
          if (row.children.length > 0) {
            row.children.forEach((res) => {
              res["number"] = row.number + "-" + res["number"].split("-")[1];
            });
          }
          if (this.tableData[idx + 1].children.length > 0) {
            this.tableData[idx + 1].children.forEach((res) => {
              res["number"] = number + "-" + res["number"].split("-")[1];
            });
          }
          this.tableData.splice(idx, 1);
          this.tableData.splice(idx + 1, 0, object);
        } else {
          let data = this.tableData[idx1].children;
          if (idx2 >= data.length - 1) {
            return false;
          }
          let n = data[idx2].number.split("-");
          let number = n[1];
          let object = data[idx2];
          data[idx2 + 1]["number"] = object.number;
          object["number"] = n[0] + "-" + (Number(number) + 1);
          data.splice(idx2, 1);
          data.splice(idx2 + 1, 0, object);
        }
      },
      // 删除表格
      deleteTableRowHandle(index, row) {
        const that = this;
        this.$confirm('确认删除该行吗?', '提示', {
          type: 'warning'
        }).then(() => {
          // 删除一级
          if (row.isAdd) {
            let idx = this.tableData.findIndex((res) => {
              return res.number == row.number;
            });
            this.tableData.splice(idx, 1);
            this.tableData.forEach((res, index1) => {
              res.number = index1 + 1;
              if (res.children.length > 0) {
                res.children.forEach((res2) => {
                  res2.number = res.number + "-" + res2.number.split("-")[1];
                });
              }
            });
          } else {
            // 删除二级
            that.dg(that.tableData, row.number);
            that.tableSelectHandle(row);
          }
        }).catch(() => {

        });
      },
      //递归删除二级行
      dg(data, keyWord) {
        for (let i in data) {
          //过滤当前新增的数据
          if (data[i].number == keyWord) {
            data.splice(i, 1);
            this.numberHandle(data);
            return false;
          }
          if (data[i].children) {
            this.dg(data[i].children, keyWord);
          }
        }
      },
      // 删除二级时重新编号
      numberHandle(data) {
        if (data.length > 0) {
          let number = data[0].number.split("-")[0];
          data.forEach((item, index) => {
            item.number = number + "-" + (index + 1);
          });
        }
      },
      // 新增一级行
      addTableRow() {
        this.cases.rate_score = 0;
        this.tableData.push({
          number: this.tableData.length + 1,
          content: '',
          total: "",
          total_select: "1",
          conversionrate: "",
          project: "",
          score: "",
          isAdd: true,
          children: []
        });
      },
      // 表格增加二级行
      addTableRowHandle(index, row) {
        if (row.children.length > 0) {
          row.children.forEach((res) => {
            row.total = Number(row.total) + Number(res.total_select);
          });
        } else {
          row.total = "1";
        }
        row.children.push({
          number: row.number + "-" + (row.children.length + 1),
          content: '',
          total: "1",
          total_select: "1",
          conversionrate: "",
          project: "",
          score: "",
        });
        if (this.cases.rate_choose == "3") {
          this.conversionrateChange();
        }
      },
      // 新增评分项
      addFlagHandle() {
        this.cases.special_score.push({
          title: '',
          score: 10,
          rate: 1
        });
      },
      // 删除新增评分项
      removeFlagHandle(index) {
        this.$confirm('确认删除该行吗?', '提示', {
          type: 'warning'
        }).then(() => {
          this.cases.special_score.splice(index, 1);
        }).catch(() => {

        });
      },
      // 折算分计算
      rate_scoreChange() {
        this.cases.rate_score = this.cases.total * this.cases.conversionRate;
      },
      // 自定义折算率分数改变
      conversionrateChange() {
        let count = 0;
        this.tableData.forEach((res, index1) => {
          if (res.conversionrate > 0) {
            count += res.total * res.conversionrate;
          } else {
            count += res.total;
          }
        });
        this.cases.rate_score = count;
      },
      // 折算方式变化清空
      rate_chooseChange() {
        this.cases.conversionRate = 0;
        this.cases.rate_score = 0;
      },
      // 计算考核点总分
      tableSelectHandle(row) {
        let idx = null;
        this.tableData.forEach((res, index1) => {
          if (res.children.length > 0) {
            res.children.forEach((res2, index2) => {
              if (row.number == res2.number) {
                idx = index1;
              }
            });
          }
        });
        if (this.tableData[idx].children.length > 0) {
          let count = 0;
          this.tableData[idx].children.forEach((res3, index2) => {
            count += Number(res3.total_select);
          });
          this.tableData[idx].total = count;
        }
      },
      download() {
        window.open(this.GLOBAL.BASE_URL + '/download/subject.xlsx')
      },
      addSubjectSupply() {
        this.subject.supply.push({
          supply_id: '',
          number: ''
        });
      },
      deleteSubjectSupply(index) {
        this.subject.supply.splice(index, 1)
      },
      handleClick(tab, event) {
        if (tab.name == 1)
          this.getSubjects();
        if (tab.name == 2)
          this.getCases();
        if (tab.name == 3)
          this.getSupplies();

      },
      //获取考试项目
      getSubjects() {
        this.$http.getSubjects(this.subjectParams)
          .then(res => {
            this.subjectList = res.data;
            this.pageformSubject.total=res.meta.total
          })
          .catch(err => {
            this.$message.error(err.message)
            console.log(err);
          })
      },
      handleAddSubject() {
        this.subject = {
          supply: []
        };
        this.subjectDialogType = 'new';
        this.subjectDialogVisible = true
      },
      handleEditSubject(scope) {
        this.subjectDialogType = 'edit';
        this.subjectDialogVisible = true;
        this.$http.getSubject(scope.row.id, {
          include: 'cases,supply'
        }).then(res => {
          this.subject = res.data;
          const cases = [];
          const supplies = [];
          res.data.cases.forEach((v) => {
            cases.push(v.id)
          })
          res.data.supply.forEach((v) => {
              supplies.push({id:v.id,number:v.pivot.num})
          })
          this.subject.cases = cases;
          this.subject.supply = supplies;
        })
      },
      confirmSubject() {
        const isEdit = this.subjectDialogType === 'edit'
        if (isEdit) {
          this.$http.updateSubject(this.subject.id, this.subject).then(res => {
            this.subjectDialogVisible = false
            this.$notify({
              title: 'Success',
              message: '操作成功！',
              type: 'success'
            })
            this.getSupplies()

          })
        } else {
          this.$http.addSubject(this.subject).then(res => {
            this.subjectDialogVisible = false
            this.$notify({
              title: 'Success',
              message: '操作成功！',
              type: 'success'
            })
            this.getSupplies()

          })
        }
      },
      deleteSubject({
        $index,
        row
      }) {
        this.$confirm('确定要删除此项目吗?', 'Warning', {
            confirmButtonText: '删除',
            cancelButtonText: '取消',
            type: 'warning'
          })
          .then(() => {
            this.$http.deleteSubject(row.id).then(res => {
              this.subjectList.splice($index, 1)
              this.$message({
                type: 'success',
                message: '删除成功!'
              })
            });

          })
          .catch(err => {
            console.error(err)
          })
      },
      getCases() {
        this.$http.getCases(this.caseParams)
          .then(res => {
            this.caseList = res.data;
            this.pageformCase.total=res.meta.total
          })
          .catch(err => {
            console.log(err);
          })
      },
      handleAddCase() {
        this.cases = {
          name: "",
          desc: "",
          total: "",
          rate_score: "",
          rate_choose: "1",
          special_score_flag: 0,
          score: "1",
          special_score: [],
          conversionRate: 0
        };
        this.tableData = [];
        this.caseDialogType = 'new';
        this.caseDialogVisible = true
      },
      handleEditCase(scope) {
          this.tableData=[]
        this.caseDialogType = 'edit';
        this.caseDialogVisible = true;
        this.$http.getCase(scope.row.id).then(res => {
          res.data.info["id"] = scope.row.id;
          res.data.info["total"] = res.data.info.score;
          if (!res.data.info.rate_score) {
            res.data.info.rate_score = 0;
          }
          if (!res.data.info.rate_choose) {
            res.data.info.rate_choose = "1";
          }
          if (!res.data.info.special_score_flag) {
            res.data.info.special_score_flag = 0;
          }
          if (!res.data.info.special_scores) {
            res.data.info.special_score = [];
            res.data.info.special_scores = [];
          } else {
            res.data.info.special_score = res.data.info.special_scores;
          }
          this.cases = res.data.info;
          let list = res.data.list;
          list.forEach((items) => {
            if (items.pid == 0) {
              this.tableData.push({
                number: items.sort,
                content: items.content, //考核点
                total: items.score, //考核点总分
                total_select: "", //考核点分数选择
                conversionrate: "", //折算率
                project: "", //考核项目
                score: items.score, //评分标准
                isAdd: true, //用于判断是否是一级数据
                children: [],
                id: items.id
              });
            }
          });
          this.tableData.forEach((items) => {
            list.forEach((item) => {
              if (item.pid != 0 && items.id == item.pid) {
                items.children.push({
                  number: items.number + "-" + item.sort,
                  content: item.content, //考核点
                  total: item.score, //考核点总分
                  total_select: item.score, //考核点分数选择
                  conversionrate: item.coefficient, //折算率
                  project: item.content, //考核项目
                  score: item.answer, //评分标准
                });
              }
            });
          });
        })
      },
      confirmCase() {
        // 制作完成后将这里的注释去除
        if (!this.cases.name) {
          this.$message.warning("请输入病例名称");
          return false;
        } else if (!this.cases.total) {
          this.$message.warning("总分不能为空");
          return false;
        } else if (this.tableData.length <= 0) {
          this.$message.warning("请添加一条考核内容");
          return false;
        }
        const isEdit = this.caseDialogType === 'edit'
        let content = [{}];
        let score = [{}];
        let description = [{}];
        this.tableData.forEach((res) => {
          let object = {
            title: res.content
          };
          let scoreObj = {
            total: res.total,
            rate: 1
          };
          let descriptionObj = {};
          if (res.children.length > 0) {
            res.children.forEach((res1, index) => {
              object[index + 1] = res1.project;
              scoreObj[index + 1] = res1.total_select;
              descriptionObj[index + 1] = res1.score;
            });
          }
          content.push(object);
          score.push(scoreObj);
          description.push(descriptionObj);
        });
        this.cases["content"] = content;
        this.cases["score"] = score;
        this.cases["description"] = description;
        if (isEdit) {
          this.$http.updateCase(this.cases.id, this.cases).then(res => {
            this.caseDialogVisible = false
            this.$notify({
              title: 'Success',
              message: '操作成功！',
              type: 'success'
            })
            this.getCases()
          }).catch(err => {
            this.$message.error(err.message)
          })
        } else {
          this.$http.addCase(this.cases).then(res => {
            this.caseDialogVisible = false
            this.$notify({
              title: 'Success',
              message: '操作成功！',
              type: 'success'
            })
            this.getCases()
          }).catch(err => {
            this.$message.error(err.message)
          })
        }
      },
      deleteCase({
        $index,
        row
      }) {
        this.$confirm('确定要删除此病例吗?', 'Warning', {
            confirmButtonText: '删除',
            cancelButtonText: '取消',
            type: 'warning'
          })
          .then(() => {
            this.$http.deleteCase(row.id).then(res => {
              this.caseList.splice($index, 1)
              this.$message({
                type: 'success',
                message: '删除成功!'
              })
            });

          })
          .catch(err => {
            console.error(err)
          })
      },
      getSupplies() {
        this.$http.getSupplies(this.supplyParams)
          .then(res => {
            this.supplyList = res.data;
              this.pageformSupply.total=res.meta.total
          })
          .catch(err => {
            console.log(err);
          })
      },
      handleAddSupply() {
        this.supply = {};
        this.supplyDialogType = 'new';
        this.supplyDialogVisible = true
      },
      handleEditSupply(scope) {
        this.supplyDialogType = 'edit';
        this.supplyDialogVisible = true;
        this.$http.getSupply(scope.row.id).then(res => {
          this.supply = res.data;
        })
      },
      confirmSupply() {
        const isEdit = this.supplyDialogType === 'edit'
        if (isEdit) {
          this.$http.updateSupply(this.supply.id, this.supply).then(res => {
            this.supplyDialogVisible = false
            this.$notify({
              title: 'Success',
              message: '操作成功！',
              type: 'success'
            })
            this.getSupplies()

          }).catch(err => {
            this.$message.error(err.message)
          })
        } else {
          this.$http.addSupply(this.supply).then(res => {
            this.supplyDialogVisible = false
            this.$notify({
              title: 'Success',
              message: '操作成功！',
              type: 'success'
            })
            this.getSupplies()

          }).catch(err => {
            this.$message.error(err.message)
          })
        }
      },
      deleteSupply({
        $index,
        row
      }) {
        this.$confirm('确定要删除此用物吗?', 'Warning', {
            confirmButtonText: '删除',
            cancelButtonText: '取消',
            type: 'warning'
          })
          .then(() => {
            this.$http.deleteSupply(row.id).then(res => {
              this.supplyList.splice($index, 1)
              this.$message({
                type: 'success',
                message: '删除成功!'
              })
            });

          })
          .catch(err => {
            console.error(err)
          })
      },
      subjectPageCurrentChange(val, e, form, jobExpLabel, pageform, searchVal) {
        // console.log('当前页:'+ val);
        this.pageformSubject.pageNum = val;
          this.subjectParams.page=val
          this.getSubjects();
      },
      casePageCurrentChange(val, e, form, jobExpLabel, pageform, searchVal) {
        // console.log('当前页:'+ val);
        this.pageformCase.pageNum = val;
          this.caseParams.page=val
        this.getCases();
      },
      supplyPageCurrentChange(val, e, form, jobExpLabel, pageform, searchVal) {
        // console.log('当前页:'+ val);
        this.pageformSupply.pageNum = val;
          this.supplyParams.page=val
          this.getSupplies();
      },
    },
  };
</script>

<style lang="less">
  .examSeting {
    .firstUl {
      list-style: none;
      padding: 0;
      margin: 0;

      .zhanfirst {
        overflow: hidden;
        margin-bottom: 20px;

        .zhanname {
          float: left;
          display: flex;

          //   align-items: center;
          label {
            font-weight: bold;
            line-height: 40px;
            height: 40px;
          }

          .el-input {
            width: 150px;
          }
        }

        .name {
          float: left;
          margin-right: 40px;
          font-weight: bold;
          line-height: 40px;
          height: 40px;
        }

        .selectRight {
          float: right;
        }
      }
    }

    .addExam {
      .time {
        width: 174px !important;

        //   input{
        //      width:174px!important;
        //   }
      }

      .add {
        margin-bottom: 20px;
      }

      min-width: 600px;
      max-width: 1000px;

      .formItem {
        overflow: hidden;
        display: flex;

        .el-form-item {}
      }
    }

    .btngroup {
      margin-top: 20px;
      text-align: right;
    }
  }
</style>



// WEBPACK FOOTER //
// src/page/resourceManage/subjects.vue